export const getFirebaseErrorMessage = code => {
  var message = null;
  switch (code) {
    case "auth/user-not-found":
      message = "User doesn't exist."
      break;
    case "auth/email-already-exists":
      message = 'Email already exist';
      break;
    case "auth/invalid-credential":
      message = 'Invalid Credential';
      break;
    case "auth/email-already-in-use":
      message = 'Email already exist';
      break;
    case "auth/invalid-email":
      message = 'Invalid Email';
      break;
    case "auth/invalid-password":
      message = 'Incorrect Password';
      break;
    case "auth/wrong-password":
      message = 'Incorrect Password';
      break;
    case "auth/missing-email":
      message = 'Missing Email';
      break;
    case "auth/too-many-requests":
      message = "You're exceed the limit. Try again after sometime.";
      break;
    case "auth/account-exists-with-different-credential":
      message = "This Email/Number Link with Another Account";
      break;
    case "auth/provider-already-linked":
      message = "This Number already link with Your Account";
      break;
    case "auth/invalid-phone-number":
      message = "Please Enter A Valid Number";
      break;
    default:
      message = 'Something went wrong';
      break;
  }
  return message;
}